import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { UiKitSpinnerComponent } from '@app/ui/components/loaders/ui-kit-spinner/ui-kit-spinner.component';

export type EventButtonSize = 'full' | '3.5' | '2.5' | '1.25';

@Component({
  selector: 'app-event-button',
  templateUrl: './event-button.component.html',
  styleUrl: './event-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [UiKitSpinnerComponent],
})
export class EventButtonComponent {
  readonly size = input<EventButtonSize>('3.5');
  readonly width = input<string>();
  readonly disabled = input(false);
  readonly loading = input(false);
  readonly buttonClick = output<MouseEvent>();
}
